module.exports = __webpack_public_path__ + "img/Video.ecae1728.svg";